import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();

  // One URL per page: strip trailing slashes client-side (canonical tags handle the crawler side)
  useEffect(() => {
    if (pathname.length > 1 && pathname.endsWith('/')) {
      navigate(pathname.replace(/\/+$/, '') + search + hash, { replace: true });
    }
  }, [pathname, search, hash, navigate]);

  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Use 'instant' for immediate scroll, 'smooth' for animated
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
